if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
// Product card mobile swipe — stack/crossfade + touch swipe
// Runs on initial load AND on every known async-injection path, since
// content set via innerHTML (recommendations, infinite scroll) never
// executes its own inline <script> tags.
(function () {
  function initSwipe(card) {
    if (card.dataset.stackInit) return;
    card.dataset.stackInit = '1';

    var link = card.querySelector('.pcard-swipe__link');
    var images = card.querySelectorAll('.pcard-swipe__image');
    var dots = card.querySelectorAll('.pcard-swipe__dot');

    if (!link || images.length < 2) return;

    var index = 0;
    var startX = 0;
    var startY = 0;
    var moved = false;

    function show(next, direction) {
      var oldIndex = index;
      var newIndex = Math.max(0, Math.min(images.length - 1, next));

      if (newIndex === oldIndex) return;

      index = newIndex;

      for (var i = 0; i < images.length; i++) {
        images[i].classList.remove(
          'is-active',
          'is-leaving-left',
          'is-leaving-right',
          'is-entering-left',
          'is-entering-right'
        );

        if (dots[i]) dots[i].classList.toggle('is-active', i === index);
      }

      var leavingClass = direction === 'right' ? 'is-leaving-right' : 'is-leaving-left';
      var enteringClass = direction === 'right' ? 'is-entering-right' : 'is-entering-left';

      images[oldIndex].classList.add(leavingClass);
      images[newIndex].classList.add(enteringClass, 'is-active');

      window.setTimeout(function () {
        images[oldIndex].classList.remove(leavingClass);
        images[newIndex].classList.remove(enteringClass);
      }, 260);
    }

    link.addEventListener('touchstart', function (event) {
      var touch = event.touches && event.touches[0];
      if (!touch) return;

      startX = touch.clientX;
      startY = touch.clientY;
      moved = false;
    }, { passive: true });

    link.addEventListener('touchend', function (event) {
      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;

      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;

      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
        moved = true;
        var isRTL = document.documentElement.dir === 'rtl' || document.body.dir === 'rtl';

        if (isRTL) {
          if (dx > 0) {
            show(index + 1, 'left');
          } else {
            show(index - 1, 'right');
          }
        } else {
          if (dx < 0) {
            show(index + 1, 'right');
          } else {
            show(index - 1, 'left');
          }
        }
      }
    }, { passive: true });

    link.addEventListener('click', function (event) {
      if (!moved) return;

      event.preventDefault();
      event.stopPropagation();

      setTimeout(function () {
        moved = false;
      }, 80);
    }, true);

    images[0].classList.add('is-active');
    if (dots[0]) dots[0].classList.add('is-active');
  }

  function runPcardSwipe() {
    document.querySelectorAll('[data-pcard-swipe]').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPcardSwipe);
  } else {
    runPcardSwipe();
  }

  var scheduled = false;
  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      runPcardSwipe();
    });
  }
  if (document.body) {
    new MutationObserver(scheduleRun).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', runPcardSwipe);
  document.addEventListener('recommendations:loaded', runPcardSwipe);
})();